import { styled } from '@mui/material/styles';

const PageContainer = styled('div')({
    paddingBottom: 16,
    '@media (max-width: 1024px)': {
        padding: 16,
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
    },
});

export default PageContainer;
